/**
 * The OwalButtonConfiguration class defines basic configuration for a model.
 *
 * @export
 * @class OwalButtonModel
 */
export class OwalButtonConfiguration {
  /**
   * Creates an instance of OwalButtonConfiguration.
   * @param {String} title The title of the button.
   * @param {String} identifier The buttons identifier.
   * @param {Function} [callback] A callback to execute when the button is clicked/tapped.
   * @param {String} URL An absolute or relative URL to render as a link.
   * @param {Boolean} destructive Describes if the button performs a "destructive" action, such as delete or undo.
   * @param {String} alignment Describes how the button lays out its content. Valid values are: "left" "right" or "center"
   * @param {String} icon A FontAwesome icon.
   * @memberof OwalButtonConfiguration
   */
  constructor ({ title, subtitle, type, identifier, callback, open, accessoryType, url, destructive, alignment, icon } = {}) {
    this.identifier = identifier
    this.title = title
    this.subtitle = subtitle
    this.callback = callback
    this.open = open
    this.accessoryType = accessoryType
    this.url = url
    this.destructive = destructive
    this.alignment = alignment
    this.icon = icon
  }
}
